/**
 * Публикации и упоминания в прессе — категория `publications` на WordPress.
 *
 * Эти материалы остаются постами WordPress в корне домена и после катовера
 * отдаются через nginx-фолбэк @wordpress (как и остальные ~4900 постов —
 * см. docs/URL-COVERAGE.md). Здесь только витрина: страница /publications/
 * обязана показывать тот же набор, что и /category/publications/ на проде,
 * иначе после переезда материалы теряют единственную точку входа из меню.
 *
 * Снято с WP REST (`?categories=1613`) 2026-08-29: 44 записи.
 * Все URL и все изображения проверены отдельно — 44/44 отвечают 200.
 * Ссылки абсолютные: это страницы WordPress, а не маршруты React.
 */
export interface Publication {
  /** Заголовок как на проде */
  title: string;
  /** Абсолютный URL поста WordPress */
  url: string;
  /** ISO-дата публикации, для сортировки и <time> */
  date: string;
  /** Ярлык рубрики — та же плашка, что на карточке архива */
  category: string;
  /** Короткая выжимка из excerpt */
  excerpt: string;
  /** Обложка. Файлы перенесены из /wp-content/ в /img/legacy/ 03.09: под движком
   * они умерли бы вместе с ним. Раскладка год/месяц сохранена — путь
   * прослеживается до оригинала. */
  image: string;
}

const SITE = 'https://www.morganlegalny.com';

/** Отсортированы от свежих к старым — как архив категории на проде. */
export const publications: Publication[] = [
  {
    title: 'Episode 2: The 4 Pillars of Law Firm Success',
    url: `${SITE}/episode-2-the-4-pillars-of-law-firm-success/`,
    date: '2025-12-25',
    category: 'Obsessed With Success',
    excerpt: 'Building a Successful Law Practice: Essential Insights from Russel Morgan The path to building a successful law practice is often shrouded in mystery, a journey that demands more than just…',
    image: `/img/legacy/2025/07/Episode-2-–-The-4-Pillars-of-Law-Firm-Success.webp`,
  },
  {
    title: 'Morgan Legal Group: Protecting Legacies, One Family at a Time',
    url: `${SITE}/morgan-legal-group-protecting-legacies-one-family-at-a-time/`,
    date: '2025-06-28',
    category: 'Estate Planning',
    excerpt: 'Honoring the Legacy of Hard Work and Protecting Your Family’s Future: The Morgan Legal Group Story At Morgan Legal Group, we understand that estate planning is more than just legal…',
    image: `/img/legacy/2025/03/morgan-post-Morgan-Legal-Group.webp`,
  },
  {
    title: 'Episode 1: Success From The Journey',
    url: `${SITE}/success-from-the-journey/`,
    date: '2025-06-27',
    category: 'Estate Planning Law',
    excerpt: 'From Refugee to Legal Pioneer: Russel Morgan’s Journey of Resilience and Success – A Comprehensive FAQ At Morgan Legal Group P.C., we are so proud of how our business came to be, and what…',
    image: `/img/legacy/2025/06/morgan-post-From-Refugee-to-Legal-Pioneer.webp`,
  },
  {
    title: 'Jeff Bezos’ Estate Plan: Billionaire Guide',
    url: `${SITE}/jeff-bezos-estate-plan-billionaire-guide/`,
    date: '2025-05-24',
    category: 'Estate Planning',
    excerpt: 'Estate Planning Strategies Inspired by Jeff Bezos Jeff Bezos’ Estate Planning Vision Jeff Bezos, the billionaire founder of Amazon, has expressed his intent to donate most of his fortune…',
    image: `/img/legacy/2025/02/morgan-post-Jeff-Bezos-Estate-Plan-What-Is-He-Going-To-Do-With-All-That-Money-.webp`,
  },
  {
    title: 'Understanding Health Care Power of Attorney in New York',
    url: `${SITE}/understanding-health-care-power-of-attorney-in-new-york/`,
    date: '2025-04-03',
    category: 'elder law',
    excerpt: 'Understanding Health Care Power of Attorney in New York: Protecting Your Medical Wishes Planning for your future healthcare needs is crucial to responsible estate planning. A Health Care…',
    image: `/img/legacy/2025/04/morgan-post-Understanding-Health-Care-Power-of-Attorney-in-New-York.webp`,
  },
  {
    title: 'The Morgan Legal Group Story',
    url: `${SITE}/the-morgan-legal-group-story/`,
    date: '2025-03-15',
    category: 'Estate Planning',
    excerpt: 'Building a Legacy: The Values That Drive Morgan Legal Group At Morgan Legal Group, we understand that estate planning is more than just legal documents. It’s about preserving your life’s…',
    image: `/img/legacy/2025/03/morgan-post-The-Morgan-Legal-Group-Story.webp`,
  },
  {
    title: 'What to Do If Your Card Is Charged Without Your Consent',
    url: `${SITE}/what-to-do-if-your-card-is-charged-without-your-consent/`,
    date: '2025-01-03',
    category: 'Publications',
    excerpt: 'Russel Morgan Shares Legal Insights on Protecting Yourself Against Unauthorized Charges Unauthorized charges can be frustrating and financially burdensome, especially from subscriptions or…',
    image: `/img/legacy/2025/01/morgan-post-What-to-Do-If-Your-Card-Is-Charged-Without-Your-Consent.webp`,
  },
  {
    title: 'Impacts of Kennedy’s Policies on Medicare & Healthcare',
    url: `${SITE}/impacts-of-kennedys-policies-on-medicare-healthcare/`,
    date: '2024-12-06',
    category: 'Medicaid And Home Care',
    excerpt: 'Analyzing the Potential Impact of Kennedy’s Healthcare Policies on Medicare Introduction Kennedy’s appointment to a pivotal role in shaping U.S. healthcare policy has sparked widespread…',
    image: `/img/legacy/2024/12/morgan-post-Impacts-of-Kennedys-Policies-on-Medicare-Healthcare.webp`,
  },
  {
    title: 'Can the President Remove the Fed Chair?',
    url: `${SITE}/can-the-president-remove-the-fed-chair/`,
    date: '2024-11-13',
    category: 'Publications',
    excerpt: 'Understanding Presidential Powers Over the Federal Reserve With growing discussions around the President’s influence over the Federal Reserve, the question of whether a sitting president…',
    image: `/img/legacy/2024/11/morgan-post-Can-the-President-Fire-Powell-How-Trump-and-the-Fed-Chair-May-Go-to-Battle.webp`,
  },
  {
    title: 'The Politics of Supreme Court Appointments',
    url: `${SITE}/the-politics-of-supreme-court-appointments/`,
    date: '2024-11-12',
    category: 'Publications',
    excerpt: 'Insights from Russell Morgan on the Supreme Court’s Future Amid Political Pressures Joining us today is Russell Morgan, founder and partner of Morgan Legal Group, to discuss the critical…',
    image: `/img/legacy/2024/11/morgan-post-Scripps-News-x-America-on-the-Docket-x-Morgan-Legal-Group-x-Sonia-Sotomayor-.webp`,
  },
  {
    title: 'Legal Analysis on the 2024 Election Results and Potential Implications',
    url: `${SITE}/legal-analysis-on-the-2024-election-results-and-potential-implications/`,
    date: '2024-11-08',
    category: 'Publications',
    excerpt: 'Russell Morgan Shares Insights on Key Legal Issues Following Recent Elections Several significant races remain undecided in light of the recent elections, leaving the nation in suspense…',
    image: `/img/legacy/2024/11/morgan-post-Legal-Analysis-on-the-2024-Election-Results-and-Potential-Implications.webp`,
  },
  {
    title: 'Legal Insight on YouTube Allegations',
    url: `${SITE}/legal-insight-on-youtube-allegations/`,
    date: '2024-11-06',
    category: 'Publications',
    excerpt: 'Cancel Culture: Legal Insight on Rosanna Pansino’s FBI Report Against MrBeast In the rapidly evolving social media landscape, allegations and accusations can surface quickly, often leading…',
    image: `/img/legacy/2024/11/morgan-post-Legal-Insight-on-YouTube-Allegations.webp`,
  },
  {
    title: 'Cancel Culture: Click to Cancel Rule Explained',
    url: `${SITE}/cancel-culture-click-to-cancel-rule-explained/`,
    date: '2024-11-05',
    category: 'Publications',
    excerpt: 'Cancel Culture: Understanding the FTC’s “Click to Cancel” Rule and What’s at Stake On October 16, the Federal Trade Commission (FTC) introduced a significant new rule to simplify online…',
    image: `/img/legacy/2024/11/morgan-post-Cancel-Culture-Click-to-Cancel-Rule-Explained.webp`,
  },
  {
    title: 'Empathy and Expertise: Russel Morgan Makes Estate Planning Accessible',
    url: `${SITE}/empathy-and-expertise-russel-morgan-makes-estate-planning-accessible/`,
    date: '2024-10-17',
    category: 'Estate Planning Law',
    excerpt: 'Providing Personalized Estate Planning Services to Protect Your Loved Ones Estate planning is a crucial process that ensures your assets are distributed according to your wishes, minimizes…',
    image: `/img/legacy/2024/10/morgan-post-Providing-Personalized-Estate-Planning-Services-to-Protect-Your-Loved-Ones.webp`,
  },
  {
    title: 'BlackRock and Blackstone: The Complete Guide to the Financial Titans and Your Estate',
    url: `${SITE}/blackrock-vs-blackstone-titans-of-the-financial-world/`,
    date: '2024-10-02',
    category: 'Publications',
    excerpt: 'Last updated: 2026-05-04 The names dominate financial news networks, corporate boardrooms, and the portfolios of institutional investors worldwide. BlackRock and Blackstone sound nearly…',
    image: `/img/legacy/2024/10/BlackRock-vs.-Blackstone-Which-Giant-is-Dominating-2024.webp`,
  },
  {
    title: 'Protecting Older Americans from Financial Scams: Insights from Attorney Russel Morgan',
    url: `${SITE}/protecting-older-americans-from-financial-scams-insights-from-attorney-russell-morgan/`,
    date: '2024-10-02',
    category: 'Publications',
    excerpt: 'Understanding the Growing Threat of Financial Scams Targeting Retirees Financial scams targeting older Americans have become a growing issue, with a significant rise in the number of…',
    image: `/img/legacy/2024/10/Protecting-Older-Americans-from-Financial-Scams-Insights-from-Attorney-Russell-Morgan.webp`,
  },
  {
    title: 'Experienced Legal Advocacy with Russel Morgan',
    url: `${SITE}/experienced-legal-advocacy-with-russel-morgan/`,
    date: '2024-09-29',
    category: 'Estate Planning',
    excerpt: 'Introducing Russel Morgan and His Mission for Justice At Morgan Legal Group, located in the heart of New York City, we focus on estate planning, probate, guardianship, elder law,…',
    image: `/img/legacy/2024/08/Inspiring-Conversations-with-Russel-Morgan-of-Morgan-Legal-Group.webp`,
  },
  {
    title: 'Legal Victory for Ex-Twitter Employee Could Spark More Severance Claims',
    url: `${SITE}/legal-victory-for-ex-twitter-employee-could-spark-more-severance-claims/`,
    date: '2024-09-25',
    category: 'Publications',
    excerpt: 'Russell Morgan Explains How Arbitration Rulings May Influence Future Settlements A former Twitter employee has won a significant legal battle over unpaid severance, a decision that could…',
    image: `/img/legacy/2024/10/morgan-post-Legal-Victory-for-Ex-Twitter-Employee-Could-Spark-More-Severance-Claims.webp`,
  },
  {
    title: 'Parental Culpability in School Shootings: Legal Insights from Russell Morgan',
    url: `${SITE}/parental-culpability-in-school-shootings-legal-insights-from-russell-morgan/`,
    date: '2024-09-15',
    category: 'Publications',
    excerpt: 'Exploring the Legal Responsibilities of Parents in School Shooting Cases Attorney Russell Morgan, founding partner at Morgan Legal Group, recently shared his expert analysis on the growing…',
    image: `/img/legacy/2024/09/morgan-post-ABC-7-WBBJ-x-Morgan-Legal-Group-x-Winder-Shooter-and-Parental-Liability.webp`,
  },
  {
    title: 'Understanding Parental Culpability in School Shootings: Insights from Russell Morgan',
    url: `${SITE}/understanding-parental-culpability-in-school-shootings-insights-from-russell-morgan/`,
    date: '2024-09-11',
    category: 'Publications',
    excerpt: 'Russell Morgan, Founding Partner at Morgan Legal Group, Explores Legal Ramifications for Parents in School Shooting Cases In a recent interview, Russell Morgan, founding partner at Morgan…',
    image: `/img/legacy/2024/09/morgan-post-Understanding-Parental-Culpability-in-School-Shootings.webp`,
  },
  {
    title: 'Holding Parents Accountable in School Shootings',
    url: `${SITE}/holding-parents-accountable-in-school-shootings/`,
    date: '2024-09-11',
    category: 'Publications',
    excerpt: 'Russell Morgan, Founder and Partner of Morgan Legal Group Discusses Evolving Legal Standards In a recent interview, Russell Morgan, founder and partner of Morgan Legal Group, provided…',
    image: `/img/legacy/2024/09/morgan-post-Scripps-News-x-America-On-The-Docket-x-Morgan-Legal-Group-x-Parents-accountability-for-childrens-actions.webp`,
  },
  {
    title: 'Disney Seeks to Dismiss Wrongful Death Suit',
    url: `${SITE}/disney-seeks-to-dismiss-wrongful-death-suit/`,
    date: '2024-08-30',
    category: 'Estate Planning Law',
    excerpt: 'Disney Seeks to Dismiss Wrongful Death Suit Due to Disney+ Agreement The tragic loss of a loved one can lead to complex legal battles, particularly when large corporations are involved.…',
    image: `/img/legacy/2024/08/Disney-Seeks-to-Dismiss-Wrongful-Death-Suit.webp`,
  },
  {
    title: 'Divorce attorneys share the most outlandish requests they’ve seen.',
    url: `${SITE}/divorce-attorneys-share-the-most-outlandish-requests-theyve-seen/`,
    date: '2024-08-29',
    category: 'Estate Planning Law',
    excerpt: 'Outlandish Divorce Requests Seen by Attorneys Divorce is often an emotional and complex process, and sometimes, people can make surprising or even outlandish requests during proceedings.…',
    image: `/img/legacy/2024/08/morgan-post-Outlandish-Divorce-Requests-Seen-by-Attorneys.webp`,
  },
  {
    title: 'How to Protect Your Assets in New York',
    url: `${SITE}/how-to-protect-your-assets-in-new-york/`,
    date: '2024-08-28',
    category: 'Estate Planning Law',
    excerpt: 'In today’s economic climate, protecting your assets is not just about saving money—it’s about strategic planning to ensure financial stability and security for the future. Russel Morgan, an…',
    image: `/img/legacy/2024/08/morgan-post-How-to-Protect-Your-Assets-in-New-York.webp`,
  },
  {
    title: 'House Republicans Release Initial Impeachment Inquiry Report on President Biden',
    url: `${SITE}/house-republicans-release-initial-impeachment-inquiry-report-on-president-biden/`,
    date: '2024-08-27',
    category: 'Estate Planning Law',
    excerpt: 'Today, House Republicans unveiled their initial impeachment inquiry report, a comprehensive document detailing allegations of abuse of power and obstruction of justice against President Joe…',
    image: `/img/legacy/2024/08/morgan-post-Russell-Morgan-Discusses-House-Republicans-Impeachment-Inquiry-into-President-Biden.webp`,
  },
  {
    title: 'The Benefits of Having a Prenuptial Agreement Before Marriage – Insights from Russel Morgan',
    url: `${SITE}/the-benefits-of-having-a-prenuptial-agreement-before-marriage-insights-from-russel-morgan/`,
    date: '2024-08-22',
    category: 'Estate Planning Law',
    excerpt: 'The Benefits of Having a Prenuptial Agreement Before Marriage Marriage is one of life’s most significant decisions, but it comes with financial and legal implications. While most couples…',
    image: `/img/legacy/2024/08/morgan-post-Russel-Morgan-Explains-the-Benefits-of-Having-a-Prenuptial-Agreement.webp`,
  },
  {
    title: 'President outlines plan to combat lack of checks and balances in government.',
    url: `${SITE}/president-outlines-plan-to-combat-lack-of-checks-and-balances-in-government/`,
    date: '2024-08-01',
    category: 'Estate Planning Law',
    excerpt: 'Russel Morgan’s Insights on Presidential Proposals for Judicial Reform Presidential Plans for Judicial Reform First and foremost, the president is laying out a plan to address the…',
    image: `/img/legacy/2024/08/President-outlines-plan-to-combat-lack-of-checks-and-balances-in-government.webp`,
  },
  {
    title: 'Video Game Actors Go On Strike',
    url: `${SITE}/video-game-actors-go-on-strike/`,
    date: '2024-07-29',
    category: 'Estate Planning Law',
    excerpt: 'Hollywood’s video game performers went on strike Friday after negotiations with major game studios came to a halt over artificial intelligence protections. Russel Morgan, a legal expert and…',
    image: `/img/legacy/2024/07/Video-Game-Actors-Go-On-Strike.webp`,
  },
  {
    title: 'Russel Morgan Named Super Lawyer for Seventh Consecutive Year',
    url: `${SITE}/russel-morgan-named-super-lawyer-for-seventh-consecutive-year/`,
    date: '2024-07-22',
    category: 'Estate Planning Law',
    excerpt: 'Russel Morgan, Founder of Morgan Legal Group, Selected for Super Lawyer 2024 List New York, NY – July 22, 2024 – Russel Morgan, Esq., founder of the Morgan Legal Group, has been selected to…',
    image: `/img/legacy/2024/07/Russel-Morgan-Named-Super-Lawyer-for-Seventh-Consecutive-Year.webp`,
  },
  {
    title: 'Russel Morgan’s Commitment to Client-Centered Legal Advocacy',
    url: `${SITE}/russel-morgans-commitment-to-client-centered-legal-advocacy/`,
    date: '2024-07-19',
    category: 'Estate Planning Law',
    excerpt: 'Russel Morgan’s Dedication to Client-Centered Legal Services According to the U.S. Consumer Legal Needs Survey, 45% of respondents who hired an attorney used online resources to help make…',
    image: `/img/legacy/2024/07/New-York-estate-litigation-attorney.webp`,
  },
  {
    title: 'Fireworks Laws',
    url: `${SITE}/fireworks-laws/`,
    date: '2024-07-11',
    category: 'Estate Planning',
    excerpt: 'Understanding Fireworks Laws in New York At Morgan Legal Group, located in New York City, we focus on estate planning, probate, guardianship, elder law, wills, and trusts. While these…',
    image: `/img/legacy/2024/07/morgan-post0ps-News-Live-x-Morgan-Legal-Group-x-Fireworks-Laws-.webp`,
  },
  {
    title: 'Legal experts remind drivers to be safe during summer holidays. 4 Jul 2024',
    url: `${SITE}/legal-experts-remind-drivers-to-be-safe-during-summer-holidays-4-jul-2024/`,
    date: '2024-07-02',
    category: 'Estate Planning Law',
    excerpt: 'Stay Safe on the Road This Summer: Legal Experts Remind Drivers As the summer holidays approach, more people take to the roads to enjoy vacations, family gatherings, and various…',
    image: `/img/legacy/2024/07/Legal-experts-remind-drivers-to-be-safe-during-summer-holidays.webp`,
  },
  {
    title: 'Seven Things to Leave Out of Your Will',
    url: `${SITE}/seven-things-to-leave-out-of-your-will/`,
    date: '2024-06-25',
    category: 'Estate Planning Law',
    excerpt: 'Seven Things to Leave Out of Your Will, According to Experts Read on Kiplinger.com At Morgan Legal Group, located in New York City, we focus on estate planning, probate, elder law,…',
    image: `/img/legacy/2024/06/Screenshot-2024-06-25-at-11.38.10 AM.webp`,
  },
  {
    title: 'Why Creating a Will is Crucial: Insights from Legal Experts',
    url: `${SITE}/why-creating-a-will-is-crucial-insights-from-legal-experts/`,
    date: '2024-06-13',
    category: 'Will',
    excerpt: 'Legal Experts Stress the Importance of Creating a Will At Morgan Legal Group, located in New York City, we focus on estate planning, probate, elder law, wills, and trusts. Creating a…',
    image: `/img/legacy/2024/06/Legal-experts-express-the-importance-of-creating-a-will.webp`,
  },
  {
    title: 'Veteran Evicted After Sale-Leaseback: A Cautionary Tale',
    url: `${SITE}/veteran-evicted-after-sale-leaseback-a-cautionary-tale/`,
    date: '2024-06-05',
    category: 'Asset Protection',
    excerpt: 'Cincinnati Veteran, 80, Living in Car After Sale-Leaseback Eviction Fred Meisberger, an 80-year-old veteran, has found himself living in his car after being evicted from his Greater…',
    image: `/img/legacy/2024/06/Cincinnati-veteran-80-is-living-in-his-car-after-selling-his-home-to-a-company-that-offered-sale-leasebacks.webp`,
  },
  {
    title: 'Legal Expert Russel Morgan Empowers Business Owners Through Financial Education and Personalized Wealth Strategies',
    url: `${SITE}/legal-expert-russel-morgan-empowers-business-owners-through-financial-education-and-personalized-wealth-strategies/`,
    date: '2024-06-05',
    category: 'Estate Planning',
    excerpt: 'Legal Expert Russel Morgan Empowers Business Owners Through Financial Education and Personalized Wealth Strategies Russel Morgan, the CEO and founder of Morgan Legal Group in New York City,…',
    image: `/img/legacy/2024/06/Legal-Expert-Russel-Morgan-Empowers-Business-Owners-Through-Financial-Education-and-Personalized-Wealth-Strategies.webp`,
  },
  {
    title: 'Top Lawyers: Russel Morgan On The 5 Things You Need To Become A Top Lawyer In Your Specific Field of Law',
    url: `${SITE}/top-lawyers-russel-morgan-on-the-5-things-you-need-to-become-a-top-lawyer-in-your-specific-field-of-law/`,
    date: '2024-06-04',
    category: 'Estate Planning',
    excerpt: 'Russel Morgan: 5 Keys to Becoming a Top Lawyer Becoming a top lawyer in a specific field of law requires dedication, expertise, and a commitment to excellence. Russel Morgan, a leading…',
    image: `/img/legacy/2024/06/Top-Lawyers-Russel-Morgan-On-The-5-Things-You-Need-To-Become-A-Top-Lawyer-In-Your-Specific-Field-of-Law.webp`,
  },
  {
    title: 'Comprehensive Guide to Estate Planning in New York',
    url: `${SITE}/estate-planning-lawyer/`,
    date: '2024-05-27',
    category: 'Estate Planning',
    excerpt: 'Estate Planning Lawyer: Comprehensive Guide to Estate Planning in New York Estate planning is a crucial process that ensures your assets are managed and distributed according to your wishes…',
    image: `/img/legacy/2024/05/What-you-need-to-know-when-deciding-to-make-a-will-Russel-Morgan.webp`,
  },
  {
    title: 'What you need to know when deciding to make a will',
    url: `${SITE}/what-you-need-to-know-when-deciding-to-make-a-will/`,
    date: '2024-05-16',
    category: 'Will',
    excerpt: 'What You Need to Know When Deciding to Make a Will It’s a startling statistic: only one in three people have a last will and testament. Despite its importance, many overlook this crucial…',
    image: `/img/legacy/2024/05/What-you-need-to-know-when-deciding-to-make-a-will-Russel-Morgan.webp`,
  },
  {
    title: 'Signs of nursing home abuse and neglect',
    url: `${SITE}/signs-of-nursing-home-abuse-and-neglect/`,
    date: '2024-04-26',
    category: 'elder law',
    excerpt: 'Signs of Nursing Home Abuse and Neglect Protecting our elderly loved ones is paramount, especially when cared for in nursing homes. Recognizing the signs of abuse and neglect can be…',
    image: `/img/legacy/2024/04/Signs-of-nursing-home-abuse-and-neglect.webp`,
  },
  {
    title: 'Elderly at risk from Will and Trust Mill scams',
    url: `${SITE}/elderly-at-risk-from-will-and-trust-mill-scams/`,
    date: '2024-04-25',
    category: 'elder law',
    excerpt: 'Alert: Seniors Targeted by Will and Trust Mill Scams Nationwide In an alarming trend, Russel Morgan, a renowned estate planning legal expert and founding partner at Morgan Legal Group in…',
    image: `/img/legacy/2024/04/Elderly-at-risk-from-Will-and-Trust-Mill-scams-1.webp`,
  },
  {
    title: 'Wills & Trusts with estate planning attorney Russel Morgan',
    url: `${SITE}/wills-trusts-with-estate-planning-expert-russel-morgan/`,
    date: '2024-04-22',
    category: 'Estate Planning',
    excerpt: 'Wills & Trusts: Essential Tools in Estate Planning with Expert Russel Morgan Understanding the intricate details of estate planning can be daunting. Russel Morgan, a seasoned estate…',
    image: `/img/legacy/2024/04/Screenshot-2024-04-21-at-9.50.58 AM.webp`,
  },
  {
    title: 'How Estate Planning Secures Your Future',
    url: `${SITE}/how-estate-planning-secures-your-future/`,
    date: '2024-04-10',
    category: 'Estate Planning',
    excerpt: 'How Will Estate Planning Help in the Future? Estate planning is a crucial process that involves preparing for the management and disposal of your estate during your life and after death. At…',
    image: `/img/legacy/2024/05/How-estate-planning-will-help-in-the-future.webp`,
  },
  {
    title: 'ABC 9 GA WTVM | Morgan Legal Group',
    url: `${SITE}/abc-9-ga-wtvm-morgan-legal-group/`,
    date: '2024-04-10',
    category: 'Estate Planning',
    excerpt: 'Understanding Estate Planning with Morgan Legal Group in New York City Estate planning is a crucial step for securing your financial future and ensuring your wishes are honored. Morgan…',
    image: `/img/legacy/2024/04/Screenshot-2024-04-21-at-10.39.58 AM.webp`,
  },
];
